var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "difference"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.90547 1.82979C10.0926 1.25385 10.9074 1.25385 11.0945 1.82979L12.717 6.82337C12.8007 7.08093 13.0408 7.25532 13.3116 7.25532H18.5621C19.1677 7.25532 19.4195 8.03024 18.9296 8.38619L14.6818 11.4724C14.4627 11.6316 14.371 11.9137 14.4547 12.1713L16.0772 17.1649C16.2643 17.7408 15.6052 18.2198 15.1152 17.8638L10.8674 14.7776C10.6483 14.6184 10.3517 14.6184 10.1326 14.7776L5.88477 17.8638C5.39484 18.2198 4.73565 17.7408 4.92279 17.1649L6.5453 12.1713C6.62899 11.9137 6.53731 11.6316 6.31821 11.4724L2.07042 8.38619C1.58049 8.03024 1.83228 7.25532 2.43786 7.25532H7.68842C7.95924 7.25532 8.19926 7.08094 8.28295 6.82337L9.90547 1.82979Z",
    fill: "#868383"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.72cf0f6776273e04e19b0d77b8269c6e.svg";
export { ForwardRef as ReactComponent };